export default __webpack_public_path__ + "images/mlh-bud-foran-bil.jpg";